import React from 'react'
import TableRow from '../../UI/TableRow'
import { SingleItemBold, SingleItemBoldColor } from '../../UI/TableItem'

type Props = {
  firstName: string
  lastName: string
  efficiency: number
  haulAverage: number
}

const KpiItem = (props: Props) => {
  const { firstName, lastName, efficiency, haulAverage } = props
  return (
    <TableRow key={firstName + lastName}>
      <SingleItemBold text={firstName + ' ' + lastName} width="15" />
      <SingleItemBoldColor
        text={efficiency + '%'}
        width="15"
        textColor={efficiency < 100 ? 'red' : 'black'}
      />
      <SingleItemBold text={haulAverage.toFixed(1) + ' mins'} width="15" />
    </TableRow>
  )
}

export default KpiItem
